module.exports = __webpack_public_path__ + "img/jsyl_kefu.e95cf095.png";